module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Card', [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(" Giro List ")]), _vm._v(" "), _c('Button', {
    attrs: {
      "slot": "extra",
      "type": "primary",
      "icon": "plus-round",
      "size": "small"
    },
    on: {
      "click": _vm.showAddGiro
    },
    slot: "extra"
  }, [_c('span', [_vm._v("Tambah Giro")])]), _vm._v(" "), _c('Row', {
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('Col', {
    attrs: {
      "span": "10"
    }
  }, [_c('ButtonGroup', {
    staticClass: "custom-group-parent"
  }, [_c('Button', {
    staticClass: "custom-group",
    staticStyle: {
      "padding": "0 1.2rem"
    }
  }, [_vm._v("Bank Account")]), _vm._v(" "), _c('Select', {
    attrs: {
      "placeholder": "Select",
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: (_vm.bankAccountId),
      callback: function($$v) {
        _vm.bankAccountId = $$v
      },
      expression: "bankAccountId"
    }
  }, _vm._l((_vm.bankAccounts), function(bankAccount) {
    return _c('Option', {
      key: bankAccount.id,
      attrs: {
        "value": bankAccount.id
      }
    }, [_vm._v(_vm._s(bankAccount.accountName))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center",
      "align-items": "center"
    },
    attrs: {
      "span": "10"
    }
  }, [_c('div', {
    staticClass: "custom-group-switch-giro"
  }, [_c('i-switch', {
    attrs: {
      "size": "large"
    },
    model: {
      value: (_vm.isGroupFilter),
      callback: function($$v) {
        _vm.isGroupFilter = $$v
      },
      expression: "isGroupFilter"
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("Group")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("Mark")])])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "move-right"
    }
  }, [_c('Select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGroupFilter == false),
      expression: "isGroupFilter == false"
    }],
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "Select Marking",
      "remote-method": _vm.getMarkingByCode,
      "loading": _vm.isLoadingGetMarking
    },
    model: {
      value: (_vm.markingHeaderIdSelected),
      callback: function($$v) {
        _vm.markingHeaderIdSelected = $$v
      },
      expression: "markingHeaderIdSelected"
    }
  }, _vm._l((_vm.optionMarkings), function(option) {
    return _c('Option', {
      key: option.value,
      attrs: {
        "value": option.value
      }
    }, [_vm._v("\n                            " + _vm._s(option.label))])
  }), 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "move-left"
    }
  }, [_c('Select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGroupFilter == true),
      expression: "isGroupFilter == true"
    }],
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "Select Group Name",
      "remote-method": _vm.getGroupMarkingByCode,
      "loading": _vm.isLoadingGetMarking
    },
    model: {
      value: (_vm.markingGroupIdSelected),
      callback: function($$v) {
        _vm.markingGroupIdSelected = $$v
      },
      expression: "markingGroupIdSelected"
    }
  }, _vm._l((_vm.optionGroupMarkings), function(option) {
    return _c('Option', {
      key: option.value,
      attrs: {
        "value": option.value
      }
    }, [_vm._v("\n                            " + _vm._s(option.label))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "3"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "icon": "ios-search"
    },
    on: {
      "click": function($event) {
        return _vm.getReceivableGiroList()
      }
    }
  }, [_c('span', [_vm._v("Cari")])])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('Row', {
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('Col', {
    attrs: {
      "span": "10"
    }
  }, [_c('ButtonGroup', {
    staticClass: "custom-group-parent"
  }, [_c('Button', {
    staticClass: "custom-group"
  }, [_vm._v("Tgl. Terima Giro")]), _vm._v(" "), _c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "daterange",
      "placeholder": "Select date"
    },
    model: {
      value: (_vm.giroDateSelected),
      callback: function($$v) {
        _vm.giroDateSelected = $$v
      },
      expression: "giroDateSelected"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "10"
    }
  }, [_c('ButtonGroup', {
    staticClass: "custom-group-parent"
  }, [_c('Button', {
    staticClass: "custom-group"
  }, [_vm._v("Tgl. Jatuh Tempo")]), _vm._v(" "), _c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "daterange",
      "placeholder": "Select date"
    },
    model: {
      value: (_vm.paymentDateSelected),
      callback: function($$v) {
        _vm.paymentDateSelected = $$v
      },
      expression: "paymentDateSelected"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "3"
    }
  }, [_c('Spin', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoadingGiroList),
      expression: "isLoadingGiroList"
    }],
    attrs: {
      "size": "large"
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('Card', [_c('button', {
    staticClass: "ivu-btn ivu-btn-default ivu-btn-small",
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.generateReport
    }
  }, [_c('span', [_vm._v("Generate PDF")])]), _vm._v(" "), _c('button', {
    staticClass: "ivu-btn ivu-btn-default ivu-btn-small",
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.generateExcel
    }
  }, [_c('span', [_vm._v("Generate XLSX")])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('Alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalGiro != 0),
      expression: "totalGiro != 0"
    }],
    attrs: {
      "type": "info",
      "show-icon": ""
    }
  }, [_vm._v(" Total Giro = " + _vm._s(_vm.totalGiro) + " lembar")]), _vm._v(" "), _c('Alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalGiro != 0),
      expression: "totalGiro != 0"
    }],
    attrs: {
      "type": "success",
      "show-icon": ""
    }
  }, [_vm._v(" Total Nominal = Rp " + _vm._s(_vm._f("numberFormatted")(_vm.totalNominal)))]), _vm._v(" "), _c('Alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalGiro != 0),
      expression: "totalGiro != 0"
    }],
    attrs: {
      "type": "warning",
      "show-icon": ""
    }
  }, [_vm._v(" Klik Mutasi untuk Generate NT pada Mutasi")]), _vm._v(" "), _c('Table', {
    attrs: {
      "row-class-name": _vm.rowClassName,
      "columns": _vm.columnsDataTable,
      "data": _vm.receivableGiroData
    }
  })], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "90%"
    },
    model: {
      value: (_vm.isModalAddGiro),
      callback: function($$v) {
        _vm.isModalAddGiro = $$v
      },
      expression: "isModalAddGiro"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#2d8cf0",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Tambah Giro List")])], 1), _vm._v(" "), _c('Form', {
    ref: "formAddGiro",
    attrs: {
      "model": _vm.formAddGiro,
      "rules": _vm.ruleValidateGiro
    }
  }, [_c('Card', [_c('Form-item', {
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_c('Row', {
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Date-picker', {
    attrs: {
      "placeholder": "Tanggal Terima Giro",
      "type": "date",
      "format": "yyyy-MM-dd"
    },
    on: {
      "on-change": _vm.isHeaderFilled
    },
    model: {
      value: (_vm.formAddGiro.giroDate),
      callback: function($$v) {
        _vm.$set(_vm.formAddGiro, "giroDate", $$v)
      },
      expression: "formAddGiro.giroDate"
    }
  })], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "Pilih Rekening Bank",
      "clearable": "",
      "filterable": ""
    },
    on: {
      "on-change": _vm.isHeaderFilled
    },
    model: {
      value: (_vm.formAddGiro.bankAccountId),
      callback: function($$v) {
        _vm.$set(_vm.formAddGiro, "bankAccountId", $$v)
      },
      expression: "formAddGiro.bankAccountId"
    }
  }, _vm._l((_vm.bankAccounts), function(bankAccount) {
    return _c('Option', {
      key: bankAccount.id,
      attrs: {
        "value": bankAccount.id
      }
    }, [_vm._v(_vm._s(bankAccount.accountName) + "\n                                  ")])
  }), 1)], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "span": "2"
    }
  }, [_c('i-switch', {
    attrs: {
      "size": "large"
    },
    model: {
      value: (_vm.isGroupAdd),
      callback: function($$v) {
        _vm.isGroupAdd = $$v
      },
      expression: "isGroupAdd"
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("Group")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("Mark")])])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('transition', {
    attrs: {
      "name": "move-up"
    }
  }, [_c('Select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGroupAdd == false),
      expression: "isGroupAdd == false"
    }],
    attrs: {
      "filterable": "",
      "placeholder": "Ketik Marking",
      "remote-method": _vm.getMarkingByCode,
      "loading": _vm.isLoadingGetMarking
    },
    on: {
      "on-change": _vm.isHeaderFilled
    },
    model: {
      value: (_vm.formAddGiro.markingHeaderId),
      callback: function($$v) {
        _vm.$set(_vm.formAddGiro, "markingHeaderId", $$v)
      },
      expression: "formAddGiro.markingHeaderId"
    }
  }, _vm._l((_vm.optionMarkings), function(option) {
    return _c('Option', {
      key: option.value,
      attrs: {
        "value": option.value
      }
    }, [_vm._v("\n                                          " + _vm._s(option.label))])
  }), 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "move-down"
    }
  }, [_c('Select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGroupAdd == true),
      expression: "isGroupAdd == true"
    }],
    attrs: {
      "filterable": "",
      "placeholder": "Ketik Group Name",
      "remote-method": _vm.getGroupMarkingByCode,
      "loading": _vm.isLoadingGetMarking
    },
    on: {
      "on-change": _vm.isHeaderFilled
    },
    model: {
      value: (_vm.formAddGiro.markingGroupId),
      callback: function($$v) {
        _vm.$set(_vm.formAddGiro, "markingGroupId", $$v)
      },
      expression: "formAddGiro.markingGroupId"
    }
  }, _vm._l((_vm.optionGroupMarkings), function(option) {
    return _c('Option', {
      key: option.value,
      attrs: {
        "value": option.value
      }
    }, [_vm._v("\n                                          " + _vm._s(option.label))])
  }), 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('Card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDetailForm),
      expression: "isDetailForm"
    }]
  }, [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(" Detail Giro(s) ")]), _vm._v(" "), _c('Button', {
    attrs: {
      "slot": "extra",
      "type": "info",
      "icon": "plus-round",
      "size": "small"
    },
    on: {
      "click": _vm.handleAdd
    },
    slot: "extra"
  }, [_c('span', [_vm._v("Tambah Giro")])]), _vm._v(" "), _c('FormItem', [_c('Row', {
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_vm._v(" Nomor atau Keterangan Giro ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_vm._v(" Nominal Giro ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_vm._v(" Tgl. Jatuh Tempo ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_vm._v(" File(s) ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "2"
    }
  })], 1)], 1), _vm._v(" "), _vm._l((_vm.formAddGiro.formDynamic.items), function(item, index) {
    return [(item.status) ? _c('FormItem', {
      key: index
    }, [_c('Row', {
      attrs: {
        "type": "flex",
        "justify": "space-between"
      }
    }, [_c('Col', {
      attrs: {
        "span": "5"
      }
    }, [_c('Input', {
      attrs: {
        "placeholder": "Nomor Giro"
      },
      model: {
        value: (_vm.formAddGiro.formDynamic.items[index].giroNumber),
        callback: function($$v) {
          _vm.$set(_vm.formAddGiro.formDynamic.items[index], "giroNumber", $$v)
        },
        expression: "formAddGiro.formDynamic.items[index].giroNumber"
      }
    })], 1), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "5"
      }
    }, [_c('money', _vm._b({
      staticClass: "ivu-input",
      model: {
        value: (_vm.formAddGiro.formDynamic.items[index].giroNominal),
        callback: function($$v) {
          _vm.$set(_vm.formAddGiro.formDynamic.items[index], "giroNominal", $$v)
        },
        expression: "formAddGiro.formDynamic.items[index].giroNominal"
      }
    }, 'money', _vm.money, false))], 1), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "5"
      }
    }, [_c('Date-picker', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "placeholder": "Tanggal Jatuh Tempo",
        "type": "date",
        "format": "yyyy-MM-dd"
      },
      model: {
        value: (_vm.formAddGiro.formDynamic.items[index].paymentDate),
        callback: function($$v) {
          _vm.$set(_vm.formAddGiro.formDynamic.items[index], "paymentDate", $$v)
        },
        expression: "formAddGiro.formDynamic.items[index].paymentDate"
      }
    })], 1), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "6"
      }
    }, [_c('Input', {
      staticStyle: {
        "display": "none"
      },
      model: {
        value: (_vm.formAddGiro.formDynamic.items[index].imageUploaded),
        callback: function($$v) {
          _vm.$set(_vm.formAddGiro.formDynamic.items[index], "imageUploaded", $$v)
        },
        expression: "formAddGiro.formDynamic.items[index].imageUploaded"
      }
    }), _vm._v(" "), _c('Upload', {
      ref: "upload",
      refInFor: true,
      attrs: {
        "type": "drag",
        "name": "fileUploaded",
        "action": _vm.serverUrlUploadFile,
        "before-upload": function (file) { return _vm.handleBeforeUpload(file, index); }
      }
    }, [_c('div', {
      staticClass: "custom-upload"
    }, [_c('Icon', {
      staticStyle: {
        "color": "#3399ff"
      },
      attrs: {
        "type": "ios-cloud-upload",
        "size": "20"
      }
    }), _vm._v(" "), _c('p', [_vm._v("Click or drag files here to upload")])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "custom-text-uploaded",
      on: {
        "click": function($event) {
          return _vm.handleDownload(index)
        }
      }
    }, [_vm._v(_vm._s(_vm.formAddGiro.formDynamic.items[index].imageUploaded))]), _vm._v(" "), _c('Progress', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.formAddGiro.formDynamic.items[index].isProgress),
        expression: "formAddGiro.formDynamic.items[index].isProgress"
      }],
      staticStyle: {
        "top": "-1rem"
      },
      attrs: {
        "percent": _vm.formAddGiro.formDynamic.items[index].pValue,
        "stroke-width": 5
      }
    })], 1), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "2"
      }
    }, [_c('Button', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "type": "error"
      },
      on: {
        "click": function($event) {
          return _vm.handleRemove(index)
        }
      }
    }, [_vm._v("Delete")])], 1)], 1)], 1) : _vm._e()]
  }), _vm._v(" "), _c('FormItem', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalGiroNominal),
      expression: "totalGiroNominal"
    }],
    staticStyle: {
      "margin": "-15px 0"
    }
  }, [_c('hr'), _vm._v(" "), _c('Row', [_c('Col', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "padding": "10px 0"
    },
    attrs: {
      "span": "5"
    }
  }, [_c('b', [_vm._v(" Total Giro :  ")]), _vm._v(" "), _c('b', [_vm._v(" Rp. " + _vm._s(_vm._f("currency")(_vm.totalGiroNominal)) + " ")])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "18"
    }
  })], 1)], 1)], 2)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDetailForm),
      expression: "isDetailForm"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.isLoadingAddGiro
    },
    on: {
      "click": _vm.postAddGiro
    }
  }, [(!_vm.isLoadingAddGiro) ? _c('span', [_vm._v("Submit")]) : _c('span', [_vm._v("On process.....")])])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "History",
      "width": "720px"
    },
    model: {
      value: (_vm.isModalHistory),
      callback: function($$v) {
        _vm.isModalHistory = $$v
      },
      expression: "isModalHistory"
    }
  }, [_c('Table', {
    attrs: {
      "columns": _vm.columnsHistory,
      "data": _vm.dataHistory
    }
  })], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "Detail(s)",
      "width": "90%"
    },
    model: {
      value: (_vm.isModalDetail),
      callback: function($$v) {
        _vm.isModalDetail = $$v
      },
      expression: "isModalDetail"
    }
  }, [_c('Table', {
    attrs: {
      "columns": _vm.columnsDetail,
      "data": _vm.dataDetail
    }
  }), _vm._v(" "), _c('br'), _c('hr'), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "1rem 0 0",
      "font-weight": "bold",
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center",
      "padding-right": "2.5rem"
    }
  }, [_c('div', [_c('Select', {
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "placeholder": "Pilih Rekening Bank",
      "searchable": "",
      "filterable": ""
    },
    model: {
      value: (_vm.formDetailGiro.bankAccountId),
      callback: function($$v) {
        _vm.$set(_vm.formDetailGiro, "bankAccountId", $$v)
      },
      expression: "formDetailGiro.bankAccountId"
    }
  }, _vm._l((_vm.bankAccounts), function(bankAccount) {
    return _c('Option', {
      key: bankAccount.id,
      attrs: {
        "value": bankAccount.id
      }
    }, [_vm._v(_vm._s(bankAccount.accountName) + "\n                    ")])
  }), 1)], 1), _vm._v(" "), _c('div', [_vm._v(" Total Giro : " + _vm._s(_vm.totalGiroNominalDetail) + " ")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "error"
    },
    on: {
      "click": function($event) {
        return _vm.showModalConfirmDetail(_vm.dataDetail)
      }
    }
  }, [_c('Icon', {
    staticStyle: {
      "padding-right": "0.5rem"
    },
    attrs: {
      "type": "refresh"
    }
  }), _vm._v(" "), _c('Span', [_vm._v(" Batalkan Semua ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "flex-end",
      "gap": "8px"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.isModalDetail = false
      }
    }
  }, [_vm._v("\n            Batal\n          ")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.updateDetailData
    }
  }, [_vm._v("\n            Update\n          ")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "Konfirmasi"
    },
    on: {
      "on-cancel": _vm.cancelUpdateGiroList
    },
    model: {
      value: (_vm.isModalConfirm),
      callback: function($$v) {
        _vm.isModalConfirm = $$v
      },
      expression: "isModalConfirm"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.confirmationMessage))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isNeedConfirm),
      expression: "isNeedConfirm"
    }]
  }, [_c('i', [_vm._v(" Tambah keterangan untuk melanjutkan ! (minimal 5 karakter)")]), _vm._v(" "), _c('Input', {
    attrs: {
      "placeholder": "notes"
    },
    model: {
      value: (_vm.confirmDescription),
      callback: function($$v) {
        _vm.confirmDescription = $$v
      },
      expression: "confirmDescription"
    }
  })], 1), _vm._v(" "), (_vm.isNeedConfirm) ? _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.confirmDescription.length >= 5),
      expression: "confirmDescription.length >= 5"
    }],
    attrs: {
      "type": "error",
      "long": ""
    },
    on: {
      "click": _vm.updateGiroList
    }
  }, [_vm._v("Ya")])], 1) : _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.cancelUpdateGiroList
    }
  }, [_vm._v("Tidak")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.updateGiroList
    }
  }, [_vm._v("Ya")])], 1)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "Konfirmasi"
    },
    on: {
      "on-cancel": _vm.cancelUpdateGiroDetail
    },
    model: {
      value: (_vm.isModalConfirmDetail),
      callback: function($$v) {
        _vm.isModalConfirmDetail = $$v
      },
      expression: "isModalConfirmDetail"
    }
  }, [_c('p', [_vm._v(" Apakah anda yakin ingin membatalkan giro ? ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isNeedConfirmDetail),
      expression: "isNeedConfirmDetail"
    }]
  }, [_c('i', [_vm._v(" Tambah keterangan untuk melanjutkan ! (minimal 5 karakter)")]), _vm._v(" "), _c('Input', {
    attrs: {
      "placeholder": "notes"
    },
    model: {
      value: (_vm.confirmDescriptionDetail),
      callback: function($$v) {
        _vm.confirmDescriptionDetail = $$v
      },
      expression: "confirmDescriptionDetail"
    }
  })], 1), _vm._v(" "), (_vm.isNeedConfirmDetail) ? _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.confirmDescriptionDetail.length >= 5),
      expression: "confirmDescriptionDetail.length >= 5"
    }],
    attrs: {
      "type": "error",
      "long": ""
    },
    on: {
      "click": _vm.updateGiroDetail
    }
  }, [_vm._v("Ya")])], 1) : _vm._e()]), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "500px"
    },
    model: {
      value: (_vm.isModalEdit),
      callback: function($$v) {
        _vm.isModalEdit = $$v
      },
      expression: "isModalEdit"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#2cb7f5",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Edit Giro")])], 1), _vm._v(" "), _c('Form', {
    ref: "formEditGiro",
    attrs: {
      "model": _vm.formEditGiro,
      "rules": _vm.ruleValidateGiro
    }
  }, [_c('Form-item', [_c('Row', [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('i-switch', {
    attrs: {
      "size": "large"
    },
    model: {
      value: (_vm.isGroupEdit),
      callback: function($$v) {
        _vm.isGroupEdit = $$v
      },
      expression: "isGroupEdit"
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("Group")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("Mark")])])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "17",
      "offset": "1"
    }
  }, [_c('transition', {
    attrs: {
      "name": "move-up"
    }
  }, [_c('Select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGroupEdit == false),
      expression: "isGroupEdit == false"
    }],
    attrs: {
      "filterable": "",
      "placeholder": "Ketik Marking",
      "remote-method": _vm.getMarkingByCode,
      "loading": _vm.isLoadingGetMarking
    },
    model: {
      value: (_vm.formEditGiro.markingHeaderId),
      callback: function($$v) {
        _vm.$set(_vm.formEditGiro, "markingHeaderId", $$v)
      },
      expression: "formEditGiro.markingHeaderId"
    }
  }, _vm._l((_vm.optionMarkings), function(option) {
    return _c('Option', {
      key: option.value,
      attrs: {
        "value": option.value
      }
    }, [_vm._v("\n                                " + _vm._s(option.label))])
  }), 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "move-down"
    }
  }, [_c('Select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGroupEdit == true),
      expression: "isGroupEdit == true"
    }],
    attrs: {
      "filterable": "",
      "placeholder": "Ketik Group Name",
      "remote-method": _vm.getGroupMarkingByCode,
      "loading": _vm.isLoadingGetMarking
    },
    model: {
      value: (_vm.formEditGiro.markingGroupId),
      callback: function($$v) {
        _vm.$set(_vm.formEditGiro, "markingGroupId", $$v)
      },
      expression: "formEditGiro.markingGroupId"
    }
  }, _vm._l((_vm.optionGroupMarkings), function(option) {
    return _c('Option', {
      key: option.value,
      attrs: {
        "value": option.value
      }
    }, [_vm._v("\n                                " + _vm._s(option.label))])
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Tanggal Terima Giro",
      "prop": "giroDate"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "200px",
      "display": "revert"
    },
    attrs: {
      "placeholder": "Tanggal Terima Giro",
      "type": "date",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.formEditGiro.giroDate),
      callback: function($$v) {
        _vm.$set(_vm.formEditGiro, "giroDate", $$v)
      },
      expression: "formEditGiro.giroDate"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Nomor Giro",
      "prop": "giroNumber"
    }
  }, [_c('Input', {
    staticStyle: {
      "display": "none"
    },
    model: {
      value: (_vm.formEditGiro.giroId),
      callback: function($$v) {
        _vm.$set(_vm.formEditGiro, "giroId", $$v)
      },
      expression: "formEditGiro.giroId"
    }
  }), _vm._v(" "), _c('Input', {
    attrs: {
      "placeholder": "Nomor Giro"
    },
    model: {
      value: (_vm.formEditGiro.giroNumber),
      callback: function($$v) {
        _vm.$set(_vm.formEditGiro, "giroNumber", $$v)
      },
      expression: "formEditGiro.giroNumber"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Nominal Giro",
      "prop": "giroNominal"
    }
  }, [_c('br'), _vm._v(" "), _c('money', _vm._b({
    staticClass: "ivu-input",
    model: {
      value: (_vm.formEditGiro.giroNominal),
      callback: function($$v) {
        _vm.$set(_vm.formEditGiro, "giroNominal", $$v)
      },
      expression: "formEditGiro.giroNominal"
    }
  }, 'money', _vm.money, false))], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Tanggal Jatuh Tempo",
      "prop": "paymentDate"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "200px",
      "display": "revert"
    },
    attrs: {
      "placeholder": "Tanggal Jatuh Tempo",
      "type": "date",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.formEditGiro.paymentDate),
      callback: function($$v) {
        _vm.$set(_vm.formEditGiro, "paymentDate", $$v)
      },
      expression: "formEditGiro.paymentDate"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Bank",
      "prop": "bankAccountId"
    }
  }, [_c('br'), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "80%",
      "display": "revert"
    },
    attrs: {
      "placeholder": "Pilih Rekening Bank",
      "clearable": ""
    },
    model: {
      value: (_vm.formEditGiro.bankAccountId),
      callback: function($$v) {
        _vm.$set(_vm.formEditGiro, "bankAccountId", $$v)
      },
      expression: "formEditGiro.bankAccountId"
    }
  }, _vm._l((_vm.bankAccounts), function(bankAccount) {
    return _c('Option', {
      key: bankAccount.id,
      attrs: {
        "value": bankAccount.id
      }
    }, [_vm._v(_vm._s(bankAccount.accountName) + "\n                    ")])
  }), 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Upload File",
      "prop": "file"
    }
  }, [_c('br'), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formEditGiro.imageUploaded),
      expression: "formEditGiro.imageUploaded"
    }],
    staticStyle: {
      "width": "100%",
      "height": "auto"
    },
    attrs: {
      "src": _vm.formEditGiro.imageUploaded,
      "alt": "Uploaded Image"
    }
  }), _vm._v(" "), _c('Input', {
    staticStyle: {
      "display": "none"
    },
    model: {
      value: (_vm.formEditGiro.markingHeaderCode),
      callback: function($$v) {
        _vm.$set(_vm.formEditGiro, "markingHeaderCode", $$v)
      },
      expression: "formEditGiro.markingHeaderCode"
    }
  }), _vm._v(" "), _c('Upload', {
    ref: "upload",
    attrs: {
      "type": "drag",
      "name": "fileUploaded",
      "action": this.serverUrlUploadFile,
      "before-upload": _vm.handleBeforeUpload
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "20px 0"
    }
  }, [_c('Icon', {
    staticStyle: {
      "color": "#3399ff"
    },
    attrs: {
      "type": "ios-cloud-upload",
      "size": "52"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Click or drag files here to upload")])], 1)]), _vm._v(" "), _c('Progress', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isProgress),
      expression: "isProgress"
    }],
    attrs: {
      "percent": _vm.pValue,
      "stroke-width": 20
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.isLoadingEditdGiro
    },
    on: {
      "click": _vm.postUpdateGiro
    }
  }, [(!_vm.isLoadingEditdGiro) ? _c('span', [_vm._v("Submit")]) : _c('span', [_vm._v("On process.....")])])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "500px"
    },
    model: {
      value: (_vm.isModalRefGiro),
      callback: function($$v) {
        _vm.isModalRefGiro = $$v
      },
      expression: "isModalRefGiro"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#2cb7f5",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Tambah Ref Giro")])], 1), _vm._v(" "), _c('Form', {
    ref: "formRefGiro",
    attrs: {
      "model": _vm.formEditGiro,
      "rules": _vm.ruleValidateGiro
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "NT Giro Lama",
      "prop": "giroNumber"
    }
  }, [_c('Input', {
    staticStyle: {
      "display": "none"
    },
    model: {
      value: (_vm.formRefGiro.giroId),
      callback: function($$v) {
        _vm.$set(_vm.formRefGiro, "giroId", $$v)
      },
      expression: "formRefGiro.giroId"
    }
  }), _vm._v(" "), _c('Select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGroupAdd == false),
      expression: "isGroupAdd == false"
    }],
    attrs: {
      "filterable": "",
      "placeholder": "Ketik NT Giro",
      "remote-method": _vm.getGiroCode,
      "clearable": "",
      "loading": _vm.isLoadingGetMarking
    },
    model: {
      value: (_vm.formRefGiro.giroNumber),
      callback: function($$v) {
        _vm.$set(_vm.formRefGiro, "giroNumber", $$v)
      },
      expression: "formRefGiro.giroNumber"
    }
  }, _vm._l((_vm.noteCodes), function(option) {
    return _c('Option', {
      key: option.value,
      attrs: {
        "value": option.value
      }
    }, [_vm._v("\n                        " + _vm._s(option.label))])
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.isLoadingEditdGiro
    },
    on: {
      "click": _vm.postUpdateRefGiro
    }
  }, [(!_vm.isLoadingEditdGiro) ? _c('span', [_vm._v("Submit")]) : _c('span', [_vm._v("On process.....")])])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "Konfirmasi",
      "ok-text": "Ya",
      "cancel-text": "Tidak"
    },
    on: {
      "on-cancel": function($event) {
        _vm.confirmDescription = ''
      }
    },
    model: {
      value: (_vm.isModalDelete),
      callback: function($$v) {
        _vm.isModalDelete = $$v
      },
      expression: "isModalDelete"
    }
  }, [_c('p', [_vm._v("Apakah anda yakin ingin menghapus pembayaran giro?")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('i', [_vm._v(" Ketik "), _c('b', [_vm._v(_vm._s(_vm.formDeleteGiro.noteCode))]), _vm._v(" untuk melanjutkan !")]), _vm._v(" "), _c('Input', {
    staticStyle: {
      "display": "none"
    },
    model: {
      value: (_vm.formDeleteGiro.giroId),
      callback: function($$v) {
        _vm.$set(_vm.formDeleteGiro, "giroId", $$v)
      },
      expression: "formDeleteGiro.giroId"
    }
  }), _vm._v(" "), _c('Input', {
    staticStyle: {
      "display": "none"
    },
    model: {
      value: (_vm.formDeleteGiro.paymentId),
      callback: function($$v) {
        _vm.$set(_vm.formDeleteGiro, "paymentId", $$v)
      },
      expression: "formDeleteGiro.paymentId"
    }
  }), _vm._v(" "), _c('Input', {
    model: {
      value: (_vm.confirmDescription),
      callback: function($$v) {
        _vm.confirmDescription = $$v
      },
      expression: "confirmDescription"
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.formDeleteGiro.noteCode).toUpperCase() == _vm.confirmDescription.toUpperCase()),
      expression: "(formDeleteGiro.noteCode).toUpperCase() == confirmDescription.toUpperCase()"
    }],
    attrs: {
      "type": "error",
      "long": ""
    },
    on: {
      "click": _vm.deleteGiroPayment
    }
  }, [_vm._v("Hapus")])], 1)]), _vm._v(" "), _c('vue-html2pdf', {
    ref: "html2Pdf",
    attrs: {
      "show-layout": false,
      "float-layout": true,
      "enable-download": true,
      "preview-modal": false,
      "paginate-elements-by-height": 1400,
      "pdf-quality": 2,
      "manual-pagination": true,
      "html-to-pdf-options": this.htmlPdfOption,
      "pdf-content-width": "100%"
    }
  }, [_c('section', {
    attrs: {
      "slot": "pdf-content"
    },
    slot: "pdf-content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "table"
  }, [_c('div', {
    staticClass: "table-header"
  }, [_c('div', {
    staticClass: "header__item"
  }, [_vm._v("Marking")]), _vm._v(" "), _c('div', {
    staticClass: "header__item"
  }, [_vm._v("Marking Group")]), _vm._v(" "), _c('div', {
    staticClass: "header__item"
  }, [_vm._v("Tgl. Terima Giro")]), _vm._v(" "), _c('div', {
    staticClass: "header__item"
  }, [_vm._v("Tgl. Jatuh Tempo")]), _vm._v(" "), _c('div', {
    staticClass: "header__item"
  }, [_vm._v("Nomor Giro")]), _vm._v(" "), _c('div', {
    staticClass: "header__item"
  }, [_vm._v("Nominal Giro")]), _vm._v(" "), _c('div', {
    staticClass: "header__item bank-header"
  }, [_vm._v("Bank")]), _vm._v(" "), _c('div', {
    staticClass: "header__item"
  }, [_vm._v("Tgl. Mundur")]), _vm._v(" "), _c('div', {
    staticClass: "header__item"
  }, [_vm._v("Kliring")]), _vm._v(" "), _c('div', {
    staticClass: "header__item"
  }, [_vm._v("Keterangan Tgl. Mundu")]), _vm._v(" "), _c('div', {
    staticClass: "header__item"
  }, [_vm._v("Keterangan Pembatalan")])]), _vm._v(" "), _c('div', {
    staticClass: "table-content"
  }, _vm._l((_vm.receivableGiroData), function(value, index) {
    return _c('section', {
      staticClass: "pdf-item"
    }, [_c('div', {
      staticClass: "table-row pdf-item",
      class: {
        'html2pdf__page-break page-break': (index + 1) % 12 === 0
      }
    }, [_c('div', {
      staticClass: "table-data"
    }, [_vm._v(_vm._s(value.marking))]), _vm._v(" "), _c('div', {
      staticClass: "table-data"
    }, [_vm._v(_vm._s(value.markingGroup))]), _vm._v(" "), _c('div', {
      staticClass: "table-data"
    }, [_vm._v(_vm._s(value.giroDate))]), _vm._v(" "), _c('div', {
      staticClass: "table-data"
    }, [_vm._v(_vm._s(value.paymentDate))]), _vm._v(" "), _c('div', {
      staticClass: "table-data"
    }, [_vm._v(_vm._s(value.giroNumber))]), _vm._v(" "), _c('div', {
      staticClass: "table-data"
    }, [_vm._v(_vm._s(value.giroNominal))]), _vm._v(" "), _c('div', {
      staticClass: "table-data bank-body"
    }, [_vm._v(_vm._s(value.accountName))]), _vm._v(" "), _c('div', {
      staticClass: "table-data"
    }, [_vm._v(_vm._s(value.dueDate))]), _vm._v(" "), _c('div', {
      staticClass: "table-data"
    }, [_vm._v(_vm._s(value.isClearing ? 'Ya' : 'Tidak'))]), _vm._v(" "), _c('div', {
      staticClass: "table-data"
    }, [_vm._v(_vm._s(value.dueNotes))]), _vm._v(" "), _c('div', {
      staticClass: "table-data"
    }, [_vm._v(_vm._s(value.cancelNotes))])]), _vm._v(" "), ((index + 1) % 12 === 0 && _vm.receivableGiroData.length !== index + 1) ? _c('div', {
      staticClass: "table-header"
    }, [_c('div', {
      staticClass: "header__item"
    }, [_vm._v("Marking")]), _vm._v(" "), _c('div', {
      staticClass: "header__item"
    }, [_vm._v("Marking Group")]), _vm._v(" "), _c('div', {
      staticClass: "header__item"
    }, [_vm._v("Tgl. Terima Giro")]), _vm._v(" "), _c('div', {
      staticClass: "header__item"
    }, [_vm._v("Tgl. Jatuh Tempo")]), _vm._v(" "), _c('div', {
      staticClass: "header__item"
    }, [_vm._v("Nomor Giro")]), _vm._v(" "), _c('div', {
      staticClass: "header__item"
    }, [_vm._v("Nominal Giro")]), _vm._v(" "), _c('div', {
      staticClass: "header__item bank-header"
    }, [_vm._v("Bank")]), _vm._v(" "), _c('div', {
      staticClass: "header__item"
    }, [_vm._v("Tgl. Mundur")]), _vm._v(" "), _c('div', {
      staticClass: "header__item"
    }, [_vm._v("Kliring")]), _vm._v(" "), _c('div', {
      staticClass: "header__item"
    }, [_vm._v("Keterangan Tgl. Mundu")]), _vm._v(" "), _c('div', {
      staticClass: "header__item"
    }, [_vm._v("Keterangan Pembatalan")])]) : _vm._e()])
  }), 0)])])])]), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "500px"
    },
    on: {
      "on-cancel": _vm.cancelAddMutasi
    },
    model: {
      value: (_vm.isModalMutasi),
      callback: function($$v) {
        _vm.isModalMutasi = $$v
      },
      expression: "isModalMutasi"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#2cb7f5",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Giro - Generate Mutasi")])], 1), _vm._v(" "), _c('Form', {
    ref: "formMutasi",
    attrs: {
      "model": _vm.formMutasi
    }
  }, [_c('Form-item', [_c('Row', [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('i-switch', {
    attrs: {
      "size": "large",
      "disabled": true
    },
    model: {
      value: (_vm.isGroupMutasi),
      callback: function($$v) {
        _vm.isGroupMutasi = $$v
      },
      expression: "isGroupMutasi"
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("Group")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("Mark")])])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "17",
      "offset": "1"
    }
  }, [_c('transition', {
    attrs: {
      "name": "move-up"
    }
  }, [_c('Select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGroupMutasi == false),
      expression: "isGroupMutasi == false"
    }],
    attrs: {
      "filterable": "",
      "placeholder": "Ketik Marking",
      "remote-method": _vm.getMarkingByCode,
      "loading": _vm.isLoadingGetMarking,
      "disabled": true
    },
    model: {
      value: (_vm.formMutasi.markingHeaderId),
      callback: function($$v) {
        _vm.$set(_vm.formMutasi, "markingHeaderId", $$v)
      },
      expression: "formMutasi.markingHeaderId"
    }
  }, _vm._l((_vm.optionMarkings), function(option) {
    return _c('Option', {
      key: option.value,
      attrs: {
        "value": option.value
      }
    }, [_vm._v("\n                                    " + _vm._s(option.label))])
  }), 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "move-down"
    }
  }, [_c('Select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGroupMutasi == true),
      expression: "isGroupMutasi == true"
    }],
    attrs: {
      "filterable": "",
      "placeholder": "Ketik Group Name",
      "remote-method": _vm.getGroupMarkingByCode,
      "loading": _vm.isLoadingGetMarking,
      "disabled": true
    },
    model: {
      value: (_vm.formMutasi.markingGroupId),
      callback: function($$v) {
        _vm.$set(_vm.formMutasi, "markingGroupId", $$v)
      },
      expression: "formMutasi.markingGroupId"
    }
  }, _vm._l((_vm.optionGroupMarkings), function(option) {
    return _c('Option', {
      key: option.value,
      attrs: {
        "value": option.value
      }
    }, [_vm._v("\n                                    " + _vm._s(option.label))])
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Tanggal Jatuh Tempo",
      "prop": "dueDate"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "200px",
      "display": "revert"
    },
    attrs: {
      "placeholder": "Tanggal Jatuh Tempo",
      "type": "date",
      "format": "yyyy-MM-dd",
      "disabled": true
    },
    model: {
      value: (_vm.formMutasi.dueDate),
      callback: function($$v) {
        _vm.$set(_vm.formMutasi, "dueDate", $$v)
      },
      expression: "formMutasi.dueDate"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Tanggal Cair",
      "prop": "paymentDate"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "200px",
      "display": "revert"
    },
    attrs: {
      "placeholder": "Tanggal Cair",
      "type": "date",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.formMutasi.paymentDate),
      callback: function($$v) {
        _vm.$set(_vm.formMutasi, "paymentDate", $$v)
      },
      expression: "formMutasi.paymentDate"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Bank",
      "prop": "bankAccountId"
    }
  }, [_c('br'), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "80%",
      "display": "revert"
    },
    attrs: {
      "placeholder": "Pilih Rekening Bank",
      "clearable": "",
      "disabled": true
    },
    model: {
      value: (_vm.formMutasi.bankAccountId),
      callback: function($$v) {
        _vm.$set(_vm.formMutasi, "bankAccountId", $$v)
      },
      expression: "formMutasi.bankAccountId"
    }
  }, _vm._l((_vm.bankAccounts), function(bankAccount) {
    return _c('Option', {
      key: bankAccount.id,
      attrs: {
        "value": bankAccount.id
      }
    }, [_vm._v(_vm._s(bankAccount.accountName) + "\n                    ")])
  }), 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Kode Nota",
      "prop": "noteCode"
    }
  }, [_c('Input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.formMutasi.noteCode),
      callback: function($$v) {
        _vm.$set(_vm.formMutasi, "noteCode", $$v)
      },
      expression: "formMutasi.noteCode"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Nominal Giro",
      "prop": "giroNominal"
    }
  }, [_c('money', _vm._b({
    staticClass: "ivu-input",
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.formMutasi.giroNominal),
      callback: function($$v) {
        _vm.$set(_vm.formMutasi, "giroNominal", $$v)
      },
      expression: "formMutasi.giroNominal"
    }
  }, 'money', _vm.money, false))], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Keterangan",
      "prop": "descriptionMutasi"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 5
      }
    },
    model: {
      value: (_vm.formMutasi.descriptionMutasi),
      callback: function($$v) {
        _vm.$set(_vm.formMutasi, "descriptionMutasi", $$v)
      },
      expression: "formMutasi.descriptionMutasi"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.isLoadingMutasi
    },
    on: {
      "click": _vm.postAddMutasi
    }
  }, [(!_vm.isLoadingMutasi) ? _c('span', [_vm._v("Submit")]) : _c('span', [_vm._v("On process.....")])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2316db90","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/giro/GiroList.vue
// module id = 1785
// module chunks = 1